import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../../components/default/header";
import StoreSidebarMenu from "../../../menu/storeSidebarMenu";
import Breadcrumb from "../../../../default/breadcrumb/breadcrumb";
import SubscriptionPackage from "../../../../subscription/subscriptionPackage";

const Subscription = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>User Store</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <StoreSidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Subscriptions</h3>
                    </div>
                    <SubscriptionPackage />
                </div>
            </div>
        </div>

    );
}

export default Subscription;